import React, { Component } from 'react';
import ExportLeadsReport from '../../ContactLeadsReport/ExportLeadsReport';
import DateRangePicker from '../../../customlib/DateRangePicker';
import { Box, Button, CircularProgress, Grid, LinearProgress } from '@mui/material';
import { Search } from '@mui/icons-material';
import Global from '../../../customlib/Global';

class Filter extends Component {
    state = {  } 
    render() { 
        return (
            <Box>
                <Grid container spacing={1}>
                    <Grid item xs={12} sx={{mb: "10px"}}>
                        {this.props.children}
                    </Grid>
                    <Grid item xs={12} sx={{mb: "20px"}}>
                        <Button color='primary' variant='contained' fullWidth onClick={() => {this.props.getContactLeads()}} size='small'>
                            Tampilkan
                        </Button>
                    </Grid>
                </Grid>
                {
                    this.props.state.isLoading === true && <LinearProgress sx={{mb: "10px"}} />
                }
            </Box>
            
        );
    }
}
 
export default Filter;